import { changePasswordRequest, loginUserRequest, logoutRequest } from "queries/auth-queries";
import { ApiResponse } from "helpers/fetch-wrapper";
import { useUserData } from "store/user-data";

// please check src/store/user-data.ts
interface User {
    username: string;
    email?: string;
    phone_number: string;
    is_business_owner: boolean;
    access_token: string; // updated
    refresh_token: string;
}

export async function signInAction(signInData: any) {
    const response = await loginUserRequest(signInData);
    const data: User = await response.json();

    const apiResponse: ApiResponse<User> = {
        body: data,
        message: data['message'],
        status: response.status,
        error: response.status === 200 ? null : data['message'],
    }

    useUserData.setState({userData: data})

    return apiResponse
}

export async function signOutAction() {
    const response = await logoutRequest();
    const data = await response.json();

    const apiResponse: ApiResponse<any> = {
        body: data,
        message: data['message'],
        status: response.status,
        error: response.status === 200 ? null : data['message'],
    }

    useUserData.setState({userData: null})

    return apiResponse
}

export async function changePasswordAction(dat: any) {
    try {
        const response = await changePasswordRequest(dat);
        const data = await response.json();

        const apiResponse: ApiResponse<any> = {
            body: data,
            message: data['message'],
            status: response.status,
            error: response.status === 200 ? null : data['message'],
        }

        return apiResponse

    } catch (err) {
        const apiResponse: ApiResponse<any> = {
            body: null,
            message: 'Failed to change password, An error occurred',
            status: 500,
            error: err,
        }

        return apiResponse
    }

}

export async function refreshTokenAction() {}
